import { ResponsiveImage } from '@/components';
import { FullPageSideElementType } from './FullPageSlideModule';
import FullPageSideElement from './FullPageSideElement';
import { ImageModel, ModuleBaseNameProps } from '@/types';

export type FullPageVideoSlideElementModel = {
  backgroundColor?: string;
  backgroundImage?: ImageModel;
  backgroundImageMobile?: ImageModel;
  mobileAlignment?: string;
  leftHandElement?: FullPageSideElementType;
  rightHandElement?: FullPageSideElementType;
} & ModuleBaseNameProps;

const FullPageSplitSlideElement = ({
  backgroundImage,
  backgroundImageMobile,
  backgroundColor,
  leftHandElement,
  rightHandElement,
}: FullPageVideoSlideElementModel) => {
  return (
    <div
      className="full-page-video-slide-element relative h-full w-full"
      style={backgroundColor ? { backgroundColor: backgroundColor } : {}}
    >
      {backgroundImage && (
        <ResponsiveImage
          image={backgroundImage}
          widths={{ xs: 425, sm: 768, md: 1024, lg: 1280, xl: 1440, xxl: 2560 }}
          heights={{ xs: 750, sm: 1024, md: 1334, lg: null, xl: null, xxl: null }}
          cdnProps={{ mode: 'crop' }}
          className="absolute top-0 right-0 left-0 hidden h-full w-full lg:block"
        />
      )}
      {backgroundImageMobile && (
        <ResponsiveImage
          image={backgroundImageMobile}
          widths={{ xs: 550, sm: 768, md: 1024 }}
          heights={{ xs: 750, sm: 1024, md: 1334 }}
          cdnProps={{ mode: 'crop' }}
          className="absolute top-0 right-0 left-0 h-full w-full lg:hidden"
        />
      )}

      <div className="utop-0 absolute left-0 flex h-full w-full px-10 lg:px-0">
        <div className="h-full lg:w-1/2">
          {leftHandElement && leftHandElement.props && <FullPageSideElement {...leftHandElement} />}
        </div>
        <div className="h-full lg:w-1/2">
          {rightHandElement && rightHandElement.props && <FullPageSideElement {...rightHandElement} />}
        </div>
      </div>
    </div>
  );
};

export default FullPageSplitSlideElement;
